// Operation colors sampled from the approved consolidation mockup.
export const LOADING_COLOR = "#5a79be";
export const DELIVERY_COLOR = "#c38b24";
export const PALE_LOADING_CARD_FILL = "color-mix(in srgb, #5a79be 8%, white)";
export const PALE_LOADING_ROW_FILL = "color-mix(in srgb, var(--dispatch-segment-loading-fill) 16%, white)";
export const PALE_DELIVERY_FILL = "color-mix(in srgb, color-mix(in srgb, var(--dispatch-segment-delivery-fill) 70%, var(--color-orange-200)) 55%, white)";
